import { ScrollContainer } from '@codezo/ui';
import { Text } from '@mantine/core';

export function DashboardPage() {
	return (
		<ScrollContainer>
			<Text size="lg" fw={600}>
				Dashboard
			</Text>
		</ScrollContainer>
	);
}
